import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  root: {
    background: theme.colors.gray[0],
  },
}));

export default useStyles;
